import {Component, EventEmitter, OnInit, Output} from '@angular/core';

declare var $: any;

@Component({
  selector: 'fx-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass'],
})
export class HeaderComponent implements OnInit {
  @Output() drawerClick = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}

  toggleMenu(): void {
    this.drawerClick.emit(true);
  }
}
